import { Component, ChangeDetectionStrategy } from '@angular/core';
import { LoaderService } from '../../services/loader/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class LoaderComponent {
  isLoading$ = this.loader.isLoading$;
  constructor(private loader: LoaderService) {}
}

